import { request_list } from '@/commons/hpod';
import { loadingData } from '@/commons/utils';
var FileSaver = require('file-saver');
import Vue from 'vue';
const viewTitle = 'báo cáo'
// initial state
const state = {
    loading: false,
    revenues: {},
    receipts: {},
    returns: {},
    summary: {},
    top_product: {},
    generals: {},
};

// getters
const getters = {};

// actions
const actions = {
    get_report({ commit }, params) {
        commit("setLoading", { loading: true });
        request_list('report/revenue-report', data => {
            commit('setRevenueReport', data);
            commit("setLoading", { loading: false });
        }, Vue.http, params, this.state.authentication.token);
    },
    get_receipt_report({ commit }, params) {
        commit("setLoading", { loading: true });
        request_list('report/receipt-report', data => {
            commit('setReceiptReport', data);
            commit("setLoading", { loading: false });
        }, Vue.http, params, this.state.authentication.token);
    },
    get_return_report({ commit }, params) {
        commit("setLoading", { loading: true });
        request_list('report/return-report', data => {
            commit('setReturnReport', data);
            commit("setLoading", { loading: false });
        }, Vue.http, params, this.state.authentication.token);
    },
    get_summary_report({ commit }, params) {
        commit("setLoading", { loading: true });
        request_list('report/summary-report', data => {
            commit('setSummaryReport', data);
            commit("setLoading", { loading: false });
        }, Vue.http, params, this.state.authentication.token);
    },
    get_top_product_report({ commit }, params) {
        commit("setLoading", { loading: true });
        request_list('report/top-product-report', data => {
            commit('setTopProductReport', data);
            commit("setLoading", { loading: false });
        }, Vue.http, params, this.state.authentication.token);
    },
    get_general_report({ commit }, params) {
        commit("setLoading", { loading: true });
        request_list('report/general-report', data => {
            commit('setGeneralReport', data);
            commit("setLoading", { loading: false });
        }, Vue.http, params, this.state.authentication.token);
    },
};

// mutations
const mutations = {
    setRevenueReport(state, data) {
        state.revenues = data;
    },
    setReceiptReport(state, data) {
        state.receipts = data;
    },
    setReturnReport(state, data) {
        state.returns = data;
    },
    setSummaryReport(state, data) {
        state.summary = data;
    },
    setTopProductReport(state, data) {
        state.top_product = data;
    },
    setGeneralReport(state, data) {
        state.generals = data;
    },
    setLoading(state, { loading }) {
        loadingData(loading);
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
